export const manifest = {
  screens: {
    scr_jwodmb: { name: "Home", route: "/" },
  },
}
